
import CalRegistrationDialogSteps from "~/components/registration/cal-registration-dialog-steps.vue";
import CalSignUp from "~/components/registration/cal-sign-up.vue";
export default {
  name: "cal-sign-up-flow",
  components: {
    CalRegistrationDialogSteps,
    CalSignUp,
  },
  props: {
    showRegistrationFlow: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    closeRegistrationFlow() {
      this.$emit("closeRegistrationFlow");
    },
  },
  data() {
    return {
      steps: [
        {
          name: "sign_up",
        },
      ],
    };
  },
};
